import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  deleteToConnectionRequestModel,
  getOneToConnectionRequestModel,
} from 'api/node/toConnectionRequestModel';
import { useSnack } from 'hooks';
import { KoobButton, KoobConfirmationModal, sanitizeRichText } from '@koob/ui';
import { useKoobStore } from '../../../../store';

const ModelItem = ({ model, reload }) => {
  const { t } = useTranslation('toConnectionRequest', {
    keyPrefix: 'models',
  });
  const [showConfirmation, setShowConfirmation] = useState(false);
  const { notify } = useSnack();

  const navigate = useNavigate();
  const setToConnectionRequestModel = useKoobStore(
    (state) => state.setToConnectionRequestModel,
  );

  const handleOpen = async (model) => {
    try {
      const { data: fullModel } = await getOneToConnectionRequestModel({
        id: model.id,
      });
      setToConnectionRequestModel(fullModel);
      navigate('/to-connection-request/bulk-edit');
    } catch (error) {
      if (error?.response?.data?.message) {
        notify(error?.response?.data?.message, { type: 'error' });
      } else {
        notify(t('errors:error'), { type: 'error' });
      }
    }
  };

  const handleDelete = async (model) => {
    try {
      await deleteToConnectionRequestModel({ id: model.id });
      reload();
    } catch (error) {
      if (error?.response?.data?.message) {
        notify(error?.response?.data?.message, { type: 'error' });
      } else {
        notify(t('errors:error'), { type: 'error' });
      }
    }
  };

  return (
    <>
      <div className="flex items-center justify-between gap-4 px-4 py-5 bg-white border border-l-4 rounded-xl">
        <div className="flex items-center gap-3 min-w-0 flex-1">
          <div className="flex items-center justify-center w-9 h-9 bg-gray-100 rounded-lg shrink-0">
            <i className="fa-regular fa-cards-blank text-gray-500" />
          </div>
          <div className="flex flex-col min-w-0 flex-1">
            <p className="text-sm font-semibold text-gray-800 truncate">
              {model.name}
            </p>
            {model.description && (
              <p
                className="text-xs text-gray-500 break-words whitespace-pre-line"
                dangerouslySetInnerHTML={{
                  __html: sanitizeRichText(model.description),
                }}
              />
            )}
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <KoobButton
            variant="primary"
            onClick={() => handleOpen(model)}
            size="sm"
          >
            {t('open')}
          </KoobButton>
          <KoobButton
            variant="primary"
            onClick={() => setShowConfirmation(true)}
            size="sm"
          >
            <i className="fa-regular fa-trash text-sm" />
          </KoobButton>
        </div>
      </div>
      {showConfirmation && (
        <KoobConfirmationModal
          open={showConfirmation}
          setOpen={setShowConfirmation}
          onConfirm={() => handleDelete(model)}
          title={t('modal.deletionTitle')}
          description={t('modal.deletionDescription')}
          danger
        />
      )}
    </>
  );
};

export default ModelItem;
